<script lang="ts" setup>
import { ref, computed, watch, nextTick, provide } from 'vue'
import PerfectScrollbarOrigin from 'perfect-scrollbar'
import { useRoute } from 'vue-router'
import { useSkins } from '../@core/composable/useSkins'
import { useAppScrollBus } from '../@core/composable/useAppScroll'

// ℹ️ This will inject classes in body tag for accurate styling
const { injectSkinClasses } = useSkins()
injectSkinClasses()

const scrollbarRef = ref<any>(null)
const lastTop = ref(0)
const lastLeft = ref(0)
const { emitScroll } = useAppScrollBus()
const route = useRoute()
provide('pageScrollbar', scrollbarRef)
// 监听路由变化，自动滚动到顶部
watch(() => route.fullPath, () => {
  nextTick(() => {
    if (scrollbarRef.value) {
      scrollbarRef.value.scrollTo(0, 0)
    }
  })
})

const handlePsScrollY = (e?: Event) => {
  const el = (scrollbarRef.value?.$el ?? scrollbarRef.value) as HTMLElement | undefined
  const scrollTop = el?.scrollTop ?? 0
  const scrollLeft = el?.scrollLeft ?? 0
  const direction = scrollTop > lastTop.value ? 'down' : scrollTop < lastTop.value ? 'up' : 'none'
  lastTop.value = scrollTop
  lastLeft.value = scrollLeft
  emitScroll({ scrollTop, scrollLeft, direction, event: e })
}
</script>

<template>
  <div ref="scrollbarRef" class="layout-wrapper" @ps-scroll-y="handlePsScrollY">
    <div class="layout-container-inner">
      <header-navigation />
      <main class="flex flex-col justify-center items-center layout-page-content">
        <slot />
      </main>
      <Footer />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.layout-wrapper {
  position: fixed;
  overflow: scroll;
  overflow-x: hidden;
  inset: 0;

  .layout-container-inner {
    min-height: 100%;
  }
}
</style>
